// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__erumy","for-panel":"Navbar_for-panel__47zFa"};